import { useQuery } from "@vue/apollo-composable";
import { GetPushMessagesDocument, OnPushMessageCreatedDocument } from "@/core/api/graphql/types";
import type { GetPushMessagesQueryVariables } from "@/core/api/graphql/types";
import type { MaybeRefOrGetter } from "vue";

let hasInitializedListener = false;

export function useGetPushMessages(payload: MaybeRefOrGetter<GetPushMessagesQueryVariables>) {
  const result = useQuery(GetPushMessagesDocument, payload, { fetchPolicy: "cache-and-network" });

  if (!hasInitializedListener) {
    result.subscribeToMore({
      document: OnPushMessageCreatedDocument,
      updateQuery: (previousQueryResult, { subscriptionData }) => {
        if (!subscriptionData.data) {
          return previousQueryResult;
        }
        const newPushMessage = subscriptionData.data.pushMessageCreated;
        const items = previousQueryResult.pushMessages?.items ?? [];
        const exists = items.some(item => item.id === newPushMessage.id);
        if (exists) {
          return previousQueryResult;
        }

        const isUnread = !newPushMessage.isRead;

        return {
          ...previousQueryResult,
          pushMessages: {
            items: [newPushMessage, ...items],
            totalCount:
              (previousQueryResult.pushMessages?.totalCount ?? 0) + 1,
          },
          unreadCount: {
            totalCount: isUnread
              ? (previousQueryResult.unreadCount?.totalCount ?? 0) + 1
              : previousQueryResult.unreadCount?.totalCount ?? 0,
          },
        };
      },
    });

    hasInitializedListener = true;
  }

  return result;
}